import { render, staticRenderFns } from "./WhyBalkam.vue?vue&type=template&id=1d821e5f&scoped=true&"
import script from "./WhyBalkam.vue?vue&type=script&lang=js&"
export * from "./WhyBalkam.vue?vue&type=script&lang=js&"
import style0 from "./WhyBalkam.vue?vue&type=style&index=0&id=1d821e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d821e5f",
  null
  
)

export default component.exports